import React from 'react';
import Collapsible from 'react-collapsible';
import './Time.css';

import JogadoresTime from './JogadoresTime';
import distinct from '../utils/distinct';

export default props => {
  const { acompanhamento = false, id, nome, escudo, open, selecionarTime, removerJogador, jogadores } = props;
  let imgEscudo;
  try {
    imgEscudo = escudo ? require(`../assets/escudos/${escudo}`) : require('../assets/escudos/semescudo.svg');
  } catch (error) {
    console.log(error);
    imgEscudo = require('../assets/escudos/semescudo.svg');
  }
  const cabecalho = (
    <span className="CabecalhoTime">
      <img alt={nome} src={imgEscudo} />
      <p>{`${nome}`}</p>
      {!acompanhamento ? <button onClick={() => selecionarTime({ id, nome })}>Selecionar</button> : null}
    </span>
  );

  const categorias = jogadores.length > 0 ? jogadores.map(item => item.categoria).filter(distinct) : [];
  const Jogadores =
    categorias.length > 0
      ? categorias.map(categoria => (
          <JogadoresTime
            acompanhamento={acompanhamento}
            key={categoria}
            jogadores={jogadores.filter(jogador => jogador.categoria === categoria)}
            categoria={categoria}
            removerJogador={removerJogador}
            idTime={id}
          />
        ))
      : null;

  return (
    <Collapsible
      trigger={cabecalho}
      transitionTime={100}
      open={open}
      onOpening={() => selecionarTime({ id, nome })}
      onClosing={() => selecionarTime({ id: 0, nome: '' })}
    >
      {jogadores.length > 0 ? Jogadores : <p>Nenhum jogador selecionado.</p>}
    </Collapsible>
  );
};
